import React from "react";
import FAQ from "./components/FAQs";

const FAQs = () => {
    
    return (
        <FAQ />
    )
};
export default FAQs;